module.exports = __webpack_public_path__ + "img/about_top.25fa2ff4.png";